import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {BlobLinkPreviewTabProvider} from 'notebook/data-tables/BlobLinkPreviewTabContext';
import isBatchesEnabled from 'registry/IsBatchesEnabled';
import StandaloneResultsView from 'results/assays/StandaloneResultsView';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

import {ResultsHeader} from './ResultsHeader';

export function EntityResultsView(props: {entityId: string}): JSX.Element {
  return (
    <div
      className="react-tab-container react-tab-container--mediocre-contentWrapper"
      {...getTestProps({component: 'EntityResultsView', element: 'root'})}
    >
      <ResultsHeader modelId={props.entityId} />
      <div className="u-small-spacing-top">
        <BlobLinkPreviewTabProvider fileId={props.entityId}>
          <StandaloneResultsView
            emptyMessage={`No ${MODEL_NAMES.results} are linked to this entity${
              isBatchesEnabled() ? ' or its batches' : ''
            }`}
            filters={{bioentityId: props.entityId}}
            includeResultsAgainstArchivedSchemas={
              BenchlingConfig.RESULTS_SHOW_ARCHIVED_SCHEMAS_ON_RESULTS_TAB
            }
          />
        </BlobLinkPreviewTabProvider>
      </div>
    </div>
  );
}

export default EntityResultsView;
